import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "flex flex-col"
}
const _hoisted_2 = { class: "flex flex-row items-start justify-between" }
const _hoisted_3 = { class: "flex flex-col" }
const _hoisted_4 = { class: "text-xl font-semibold" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500" }, " You are receiving the following notifications ", -1)
const _hoisted_6 = { class: "flex flex-row items-center" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "mr-4" }, "Job notifications", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "w-full h-px bg-gray-300 my-4" }, null, -1)
const _hoisted_9 = { class: "grid grid-rows-4 grid-flow-col" }
const _hoisted_10 = { class: "capitalize ml-2" }
const _hoisted_11 = { class: "flex flex-row justify-end mt-8" }
const _hoisted_12 = ["disabled", "onClick"]
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loader = _resolveComponent("Loader")!
  const _component_SwitchButton = _resolveComponent("SwitchButton")!
  const _component_Checkbox = _resolveComponent("Checkbox")!

  return (_ctx.loading)
    ? (_openBlock(), _createBlock(_component_Loader, { key: 0 }))
    : (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.jobs, (job, i) => {
          return (_openBlock(), _createElementBlock("div", {
            key: i,
            class: "flex flex-col card-main mb-4"
          }, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("span", _hoisted_4, _toDisplayString(job.job?.title), 1),
                _hoisted_5
              ]),
              _createElementVNode("div", _hoisted_6, [
                _hoisted_7,
                _createVNode(_component_SwitchButton, {
                  modelValue: _ctx.toggles[i],
                  "onUpdate:modelValue": ($event: any) => ((_ctx.toggles[i]) = $event),
                  onClick: ($event: any) => (_ctx.setAllNotifications(i))
                }, null, 8, ["modelValue", "onUpdate:modelValue", "onClick"])
              ])
            ]),
            _hoisted_8,
            _createElementVNode("div", _hoisted_9, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(job.notifications, (notification, name) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: name,
                  class: "flex flex-row items-center mt-2"
                }, [
                  _createVNode(_component_Checkbox, {
                    selected: notification.value,
                    "onUpdate:selected": ($event: any) => ((notification.value) = $event),
                    disabled: notification.disabled,
                    onClick: ($event: any) => (_ctx.setToggles(i))
                  }, null, 8, ["selected", "onUpdate:selected", "disabled", "onClick"]),
                  _createElementVNode("span", _hoisted_10, _toDisplayString(String(name).replaceAll("_", " ")), 1)
                ]))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("button", {
                class: _normalizeClass({
            'btn-filled-sm': !_ctx.loadingSave,
            'btn-filled-sm-loading': _ctx.loadingSave,
          }),
                disabled: _ctx.loadingSave,
                onClick: ($event: any) => (_ctx.saveChanges(i))
              }, [
                (!_ctx.loadingSave)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_13, "Save"))
                  : (_openBlock(), _createElementBlock("span", _hoisted_14, "Loading..."))
              ], 10, _hoisted_12)
            ])
          ]))
        }), 128))
      ]))
}